import { ModelInfoList, ModelsApi } from "../../types";
import { modelsDescriptionMap } from "../../constants";

export const modelSerializer = (data: ModelsApi): ModelInfoList => {
  return {
    models: data.models.map((model) => ({
      modelId: model.name,
      name: modelsDescriptionMap[model.name]?.name || model.name,
      description: modelsDescriptionMap[model.name]?.description || "",
      supportedFileTypes: model.supported_file_types.map((fileType) => {
        /*TODO: To be removed as part of SPEC-4080
         * Remove mapping after backend updated.
         * */
        switch (fileType) {
          case "pdf":
            return "application/pdf";
          case "docx":
            return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          case "xlsx":
            return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          default:
            return fileType;
        }
      }),
      provider: model.model_provider,
    })),
    defaultModelId: data.default_model,
  };
};
